/* YPRT Reviews — laedt weitere Judge.me-Bewertungen ueber die oeffentliche Widget-API.
   Endpoint: GET https://judge.me/api/v1/widgets/all_reviews_page (Public Token, nur lesend).
   Liefert Produkt- und Shop-Bewertungen gemeinsam als HTML; wir lesen daraus nur die Daten
   und bauen eigene Karten (keine Fremd-HTML-Injektion). */
(function () {
  var STAR = 'M12 2.5l2.9 6.1 6.6.8-4.9 4.5 1.3 6.6L12 17.3l-5.9 3.2 1.3-6.6-4.9-4.5 6.6-.8z';
  var SVGNS = 'http://www.w3.org/2000/svg';

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function stars(rating) {
    var wrap = el('span', 'yprt-stars');
    wrap.setAttribute('role', 'img');
    wrap.setAttribute('aria-label', rating + ' out of 5 stars');
    wrap.style.setProperty('--yprt-star-empty', '#D9D9D9');
    ['yprt-stars__base', 'yprt-stars__fill'].forEach(function (cls, i) {
      var row = el('span', cls);
      if (i === 1) row.style.width = (rating * 20) + '%';
      for (var k = 0; k < 5; k++) {
        var svg = document.createElementNS(SVGNS, 'svg');
        svg.setAttribute('width', '16'); svg.setAttribute('height', '16');
        svg.setAttribute('viewBox', '0 0 24 24'); svg.setAttribute('aria-hidden', 'true');
        var p = document.createElementNS(SVGNS, 'path');
        p.setAttribute('d', STAR); p.setAttribute('fill', 'currentColor');
        svg.appendChild(p); row.appendChild(svg);
      }
      wrap.appendChild(row);
    });
    return wrap;
  }

  function check() {
    var svg = document.createElementNS(SVGNS, 'svg');
    svg.setAttribute('width', '11'); svg.setAttribute('height', '11'); svg.setAttribute('viewBox', '0 0 24 24');
    svg.setAttribute('fill', 'none'); svg.setAttribute('stroke', '#F4C549'); svg.setAttribute('stroke-width', '3');
    svg.setAttribute('aria-hidden', 'true');
    var p = document.createElementNS(SVGNS, 'path'); p.setAttribute('d', 'M5 12l5 5L20 7');
    svg.appendChild(p);
    return svg;
  }

  function formatDate(str) {
    if (!str) return '';
    var d = new Date(str.replace(' UTC', 'Z').replace(' ', 'T'));
    if (isNaN(d)) return '';
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  }

  function textOf(node) {
    if (!node) return '';
    var parts = [];
    node.querySelectorAll('p').forEach(function (p) {
      p.querySelectorAll('br').forEach(function (br) { br.replaceWith('\n'); });
      parts.push(p.textContent.trim());
    });
    return (parts.length ? parts.join('\n\n') : node.textContent).trim();
  }

  // Liest eine Judge.me-Review (div.jdgm-rev) in ein schlichtes Objekt.
  function parseReview(node) {
    var q = function (s) { return node.querySelector(s); };
    var link = q('.jdgm-rev__prod-link');
    // Shop-Bewertungen verlinken bei Judge.me auf "/" — nicht als Produkt anzeigen
    if (link && !/\/products\//.test(link.getAttribute('href') || '')) link = null;
    var badges = Array.prototype.map.call(node.querySelectorAll('[data-badge-type]'), function (b) {
      return b.getAttribute('data-badge-type') || '';
    }).join(' ') + ' ' + ((q('[data-source]') || {}).getAttribute ? q('[data-source]').getAttribute('data-source') : '');
    var source = /etsy/i.test(badges) ? 'Etsy' : (/google/i.test(badges) ? 'Google' : '');
    var pics = Array.prototype.map.call(node.querySelectorAll('.jdgm-rev__pics img'), function (img) {
      return img.getAttribute('data-src') || img.getAttribute('src') || '';
    }).filter(function (u) { return /^https:\/\//.test(u); });
    var scoreEl = q('[data-score]');
    var ts = q('.jdgm-rev__timestamp');
    return {
      id: node.getAttribute('data-review-id'),
      rating: scoreEl ? parseInt(scoreEl.getAttribute('data-score'), 10) || 0 : 0,
      date: formatDate(ts && (ts.getAttribute('data-content') || ts.getAttribute('datetime'))),
      name: (q('.jdgm-rev__author') || {}).textContent || '',
      verified: node.getAttribute('data-verified-buyer') === 'true',
      source: source,
      title: ((q('.jdgm-rev__title') || {}).textContent || '').trim(),
      body: textOf(q('.jdgm-rev__body')),
      pics: pics.slice(0, 4),
      reply: ((q('.jdgm-rev__reply-content') || {}).textContent || '').trim(),
      product: link ? link.textContent.trim().split(' - ')[0] : '',
      productUrl: link ? link.getAttribute('href') : ''
    };
  }

  // "handle = Anzeigename = /products/ziel" je Zeile (Section-Setting), Ziel optional.
  function parseNames(str) {
    var map = {};
    (str || '').split(/\r?\n/).forEach(function (line) {
      var p = line.split('=').map(function (x) { return x.trim(); });
      if (p[0] && p[1]) map[p[0]] = { label: p[1], url: p[2] || '' };
    });
    return map;
  }

  function applyName(r, names) {
    var m = (r.productUrl || '').match(/\/products\/([^/?#]+)/);
    var hit = m && names[m[1]];
    if (hit) {
      r.product = hit.label;
      if (/^\//.test(hit.url)) r.productUrl = hit.url;
    }
    return r;
  }

  function card(r) {
    var a = el('article', 'yprt-rv__card');
    a.setAttribute('data-id', r.id);
    var top = el('div', 'yprt-rv__card-top');
    top.appendChild(stars(r.rating));
    top.appendChild(el('span', 'yprt-rv__date', r.date));
    a.appendChild(top);

    var who = el('div', 'yprt-rv__who');
    who.appendChild(el('span', 'yprt-rv__name', r.name.trim()));
    // Etsy-Importe zeigen nur den Etsy-Tag – "Verified" steht fuer Kaeufer in unserem Shop
    if (r.verified) {
      var v = el('span', 'yprt-rv__badge yprt-rv__badge--verified');
      v.appendChild(check()); v.appendChild(document.createTextNode('Verified'));
      who.appendChild(v);
    }
    if (r.source) who.appendChild(el('span', 'yprt-rv__badge yprt-rv__badge--source', r.source));
    a.appendChild(who);

    if (r.title) a.appendChild(el('p', 'yprt-rv__title', r.title));
    var body = el('p', 'yprt-rv__body', r.body);
    body.style.whiteSpace = 'pre-line';
    a.appendChild(body);

    if (r.pics.length) {
      var pics = el('div', 'yprt-rv__pics');
      r.pics.forEach(function (u) {
        var img = el('img'); img.src = u; img.alt = 'Photo from ' + r.name.trim();
        img.loading = 'lazy'; img.width = 72; img.height = 72;
        pics.appendChild(img);
      });
      a.appendChild(pics);
    }
    if (r.reply) {
      var rep = el('div', 'yprt-rv__reply');
      rep.appendChild(el('strong', null, 'Reply from Your PR Tracker'));
      rep.appendChild(el('span', null, r.reply));
      a.appendChild(rep);
    }
    var prod = el('span', 'yprt-rv__product');
    if (r.product && /^\//.test(r.productUrl || '')) {
      prod.appendChild(document.createTextNode('Reviewed: '));
      var l = el('a', null, r.product); l.href = r.productUrl;
      prod.appendChild(l);
    } else if (r.product) {
      prod.textContent = 'Reviewed: ' + r.product;
    } else {
      prod.textContent = 'Review about our shop';
    }
    a.appendChild(prod);
    return a;
  }

  function init(root) {
    var token = root.getAttribute('data-token');
    var shop = root.getAttribute('data-shop');
    var perPage = parseInt(root.getAttribute('data-per-page'), 10) || 10;
    var total = parseInt(root.getAttribute('data-total'), 10) || 0;
    var names = parseNames(root.getAttribute('data-names'));
    var list = root.querySelector('[data-yprt-list]');
    var more = root.querySelector('[data-yprt-more]');
    var sort = root.querySelector('[data-yprt-sort]');
    var error = root.querySelector('[data-yprt-error]');
    if (!token || !shop || !list) return;

    var seen = {};
    list.querySelectorAll('[data-id]').forEach(function (n) { seen[n.getAttribute('data-id')] = true; });
    // Die erste Seite kommt serverseitig (neueste zuerst); weiter geht es ab der passenden API-Seite.
    var page = Math.floor(list.children.length / perPage) + 1;
    var sortVal = '';
    var busy = false;

    function updateMore(lastBatch) {
      if (!more) return;
      // Nur auf die gelieferten Bewertungen verlassen: die Gesamtzahl von Judge.me kann (z. B. nach Importen) hinterherhinken
      var done = lastBatch < perPage;
      more.hidden = done;
      more.disabled = false;
    }

    function load(reset) {
      if (busy) return;
      busy = true;
      if (more) more.disabled = true;
      if (error) error.hidden = true;
      var url = 'https://judge.me/api/v1/widgets/all_reviews_page?shop_domain=' + encodeURIComponent(shop) +
        '&api_token=' + encodeURIComponent(token) + '&per_page=' + perPage + '&page=' + page +
        '&review_type=all-reviews'; // ohne diesen Parameter fehlen die Shop-Bewertungen
      if (sortVal) {
        var s = sortVal.split(':');
        url += '&sort_by=' + s[0] + '&sort_dir=' + s[1];
      }
      fetch(url)
        .then(function (res) { if (!res.ok) throw new Error(res.status); return res.json(); })
        .then(function (data) {
          var doc = new DOMParser().parseFromString(data.all_reviews || '', 'text/html');
          var nodes = doc.querySelectorAll('.jdgm-rev[data-review-id]');
          if (reset) { list.innerHTML = ''; seen = {}; }
          nodes.forEach(function (n) {
            var r = applyName(parseReview(n), names);
            if (!r.id || seen[r.id]) return;
            seen[r.id] = true;
            list.appendChild(card(r));
          });
          page += 1;
          updateMore(nodes.length);
        })
        .catch(function () {
          if (error) error.hidden = false;
          if (more) more.disabled = false;
        })
        .then(function () { busy = false; });
    }

    if (more) more.addEventListener('click', function () { load(false); });
    // Erste Seite sofort live von Judge.me holen (Metafelder koennen nach Importen veraltet sein)
    page = 1;
    load(true);
    if (sort) sort.addEventListener('change', function () {
      sortVal = sort.value;
      page = 1;
      load(true);
    });
  }

  // Der Instant-Header ist position: fixed — seine echte Hoehe als CSS-Variable setzen.
  function setHeaderOffset() {
    var group = document.querySelector('.shopify-section-group-header-group');
    if (!group) return;
    var bottom = 0;
    group.querySelectorAll('*').forEach(function (n) {
      if (getComputedStyle(n).position !== 'fixed') return;
      var r = n.getBoundingClientRect();
      if (r.top <= 1 && r.height > 30 && r.height < 300) bottom = Math.max(bottom, r.bottom);
    });
    if (bottom) document.documentElement.style.setProperty('--yprt-header-h', Math.round(bottom) + 'px');
  }

  function boot() {
    if (document.querySelector('.yprt-rv--offset')) {
      setHeaderOffset();
      window.addEventListener('resize', setHeaderOffset);
    } document.querySelectorAll('[data-yprt-reviews]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
